import { calculatePerpetualFlatDiscount } from "../../discountCommons/index.js";
import { calculatePercentageDiscount } from "../../discountCommons/index.js";
import { calculateItemTotal } from "../../orderCommons/index.ts";
import {
  type PriceTierDiscountItemType,
  type PriceTierDiscountType,
  filterDiscountApplicableItems,
} from "../priceTierDiscountCommons.js";
import { groupItemsByCaseSizeRules } from "../../orderRules/index.js";

export const calculatePriceTierDiscount = ({
  orderItems,
  priceTierDiscount,
  caseSizeRuleList,
}: {
  orderItems: {
    quantity: number;
    packQuantity: number | null;
    volume: number | null;
    containerType: string | null;
    price: number;
    discountable: boolean;
    unit: string | null;
  }[];
  priceTierDiscount:
    | {
        type: PriceTierDiscountType;
        amount: number;
        itemType: PriceTierDiscountItemType | null;
      }
    | undefined;
  caseSizeRuleList: {
    quantity: number;
    containerType: "can" | "bottle";
    volume: number;
    unit: string;
  }[];
}) => {
  if (!priceTierDiscount) return 0;

  const discountApplicableOrderItems = filterDiscountApplicableItems({
    orderItems,
    discountItemType: priceTierDiscount.itemType,
  });

  const itemTotal = calculateItemTotal(
    discountApplicableOrderItems.map((orderItem) => ({
      price: orderItem.price,
      quantity: orderItem.quantity,
    })),
  );

  switch (priceTierDiscount.type) {
    case "perpetual-flat": {
      const orderItemsGroupedByCaseSizeRules = groupItemsByCaseSizeRules({
        orderItemList: discountApplicableOrderItems,
        caseSizeRuleList,
      }).map(({ quantity }) => ({
        // whole cases only considered with discount
        quantity: Math.floor(quantity),
      }));

      return calculatePerpetualFlatDiscount({
        flatItemDiscount: priceTierDiscount.amount,
        orderItems: orderItemsGroupedByCaseSizeRules,
        totalValue: itemTotal,
      });
    }
    case "percentage": {
      return calculatePercentageDiscount(itemTotal, priceTierDiscount.amount);
    }
  }
};
